export enum DispositionCode {
    Empty,
    Completed,
    Dropped,
    ScreenedOut,
    Interrupted,
    OutOfQuota,
    Reset,
}
